import React from 'react';

import { AnonymousDirectoryCard } from './AnonymousDirectoryCard';
import { EmptyDirectoryCard } from './EmptyDirectoryCard';
import { ExpertDirectoryCard } from './ExpertDirectoryCard';
import { ProductDirectoryCard } from './ProductDirectoryCard';
import type { DirectoryCardProps } from './types';
import { DirectoryCardErrorBoundary } from '../DirectoryCardErrorBoundary';

/**
 * Renders the appropriate directory card variant based on item type.
 * Encapsulates type-switching logic and error boundary wrapping.
 */
export const DirectoryCard = React.memo(function DirectoryCard({
  item,
  isMultiColumn,
  showExplainerAffordances,
  buildInquiryUrl,
  featuredExpertIds,
}: DirectoryCardProps) {
  switch (item.type) {
    case 'empty':
      return <EmptyDirectoryCard id={item.id} />;

    case 'anonymous':
      return (
        <DirectoryCardErrorBoundary expertId={item.data.id}>
          <AnonymousDirectoryCard
            item={item.data}
            isMultiColumn={isMultiColumn}
            buildInquiryUrl={buildInquiryUrl}
          />
        </DirectoryCardErrorBoundary>
      );

    case 'expert':
      return (
        <DirectoryCardErrorBoundary expertId={item.data.id}>
          <ExpertDirectoryCard
            item={item.data}
            isMultiColumn={isMultiColumn}
            buildInquiryUrl={buildInquiryUrl}
            showFeaturedBadge={featuredExpertIds.has(String(item.data.id))}
          />
        </DirectoryCardErrorBoundary>
      );

    case 'product':
      return (
        <DirectoryCardErrorBoundary expertId={item.data.id}>
          <ProductDirectoryCard
            item={item.data}
            isMultiColumn={isMultiColumn}
            showExplainerAffordances={showExplainerAffordances}
          />
        </DirectoryCardErrorBoundary>
      );
  }
});
